<template>
  <div class="cart-cashback">
    <div v-if="isAuthenticated" class="cart-cashback--auth">
      {{ $t('cart.cashback.order_today') }}
      <strong class="cart-cashback__bonuses">{{
        $t('cart.cashback.bonuses_amount', {
          bonuses: cashback
        })
      }}</strong>
    </div>

    <div v-else id="cart-cashback-auth" class="cart-cashback--not-auth">
      <BaseButton
        theme="link"
        @click="handleSignIn"
      >
        {{ $t('cart.cashback.sign_in') }}
      </BaseButton>
      {{ $t('cart.cashback.and_get') }}
      <strong class="cart-cashback__bonuses">{{
        $t('cart.cashback.bonuses_amount', {
          bonuses: cashback
        })
      }}</strong>
      {{ $t('cart.cashback.for_purchase') }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import { modalAuthId } from '@/constants/modalNames'

type Props = {
  cashback: number
  isAuthenticated: boolean
}
defineProps<Props>()

const { $vfm } = useNuxtApp()
const handleSignIn = () => {
  $vfm.open(modalAuthId, { form: 'login' })
}

</script>

<style lang="scss">
.cart-cashback {
  @media only screen and (max-width: 740px) {
    margin-top: 1.2rem;
    line-height: $line-height-16;
  }
  @media only screen and (min-width: 740px) {
    width: 23.6rem;
  }

  &--auth {
    @media only screen and (min-width: 740px) {
      max-width: 17rem;
    }
  }
  &--not-auth {
    @media only screen and (min-width: 740px) {
      max-width: 19rem;
    }
  }

  &__bonuses {
    white-space: nowrap;
    font-weight: 500;
    color: $font-accent-color;
  }
}
</style>
